// File: src/components/ThankYou.jsx
export default function ThankYou() {
    return (
        <div className="min-h-screen bg-black text-white flex items-center justify-center px-6">
            <div className="text-center">
                <h2 className="text-4xl font-bold mb-4">Thank You!</h2>
                <p className="text-gray-400 text-lg">We have received your message and will get back to you shortly.</p>
            </div>
        </div>
    );
}